import {
  GET_INJURED_BANNED_DATA_REQUEST,
  GET_INJURED_BANNED_DATA_SUCCESS,
  GET_INJURED_BANNED_DATA_FAILURE,
  RESET_MATCH_CARD
} from 'Store/constants';

const initialState = {
  data: {},
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_INJURED_BANNED_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_INJURED_BANNED_DATA_SUCCESS:
      return { ...state, data: { ...action.payload }, isLoading: false, error: null };
    case GET_INJURED_BANNED_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case RESET_MATCH_CARD:
      return { ...initialState };

    default:
      return state;
  }
};
